import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ShopSales').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  heading: {
    fontWeight: '450',
    fontSize: '24px',
    textAlign: 'center',
    color: 'white',
    padding: '24px 0px',
  },

  subHeading: {
    fontWeight: '450',
    fontSize: '18px',
    textAlign: 'left',
    color: 'white',
  },

  nothingHere: {
    fontWeight: '300',
    fontSize: '18px',
    paddingTop: '24px',
    textAlign: 'center',
    color: theme.colors.text.secondary,
  },

  offersContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
}))
